// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'cloud';

export const Component = () => (
  <path d='M17.71 7.921c-.815 0-1.533.144-2.204.431C14.117 6.102 12.058 5 9.376 5c-2.06 0-3.784.719-5.22 2.107C2.718 8.544 2 10.268 2 12.327c0 1.964.67 3.64 2.012 5.03 1.293 1.388 2.92 2.202 4.837 2.346h8.86c1.628 0 3.018-.575 4.167-1.724 1.149-1.15 1.724-2.538 1.724-4.166 0-1.629-.575-3.018-1.724-4.167-1.15-1.15-2.539-1.724-4.167-1.724Zm0 10.776H8.944c-1.676-.144-3.065-.814-4.215-2.012-1.15-1.197-1.724-2.682-1.724-4.358 0-1.772.623-3.257 1.868-4.502C6.12 6.58 7.604 5.957 9.376 5.957c2.347 0 4.262 1.198 5.795 3.592.719-.383 1.58-.622 2.538-.67 1.39 0 2.539.479 3.496 1.437.958.957 1.437 2.107 1.437 3.496 0 1.34-.479 2.49-1.437 3.448-.957.958-2.107 1.437-3.496 1.437Z' />
);

export const viewBox = '0 0 25 25';
